import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit} from '@angular/core';
import {filter, map, tap} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {ErrorService} from "../api/error/error.service";
import {IonToast} from "@ionic/angular/standalone";
import {LoggerService} from "../api/logging/logger.service";

@Component({
  selector: 'app-error',
  templateUrl: 'error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonToast
  ]
})
export class ErrorComponent implements OnInit, OnDestroy {
  private readonly errorService = inject(ErrorService);
  private readonly loggingService = inject(LoggerService);
  private readonly cdr = inject(ChangeDetectorRef);

  isToastOpen = false;
  message: string | null = null;
  public toastButtons = [
    {
      text: 'Dismiss',
      role: 'cancel',
      handler: () => {
        this.dismiss();
      }
    }
  ]

  error$ = this.errorService.error$.pipe(
    filter(error => error != null),
    tap(error => this.loggingService.error('Error received in error component: ', error)),
    map(error => {
      this.showToast(error);
    })
  );

  errorSub!: Subscription;

  clearError(): void {
    this.errorService.clearError();
  }

  dismiss() {
    this.isToastOpen = false;
    this.clearError();
  }

  showToast(message: string | null) {
    this.message = message ?? 'Unknown error';
    this.isToastOpen = true;
    this.cdr.markForCheck();
  }

  ngOnInit(): void {
    this.errorSub = this.error$.subscribe();
  }

  ngOnDestroy(): void {
    this.errorSub.unsubscribe();
  }


}
